var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overview"},[_c('masonry',{attrs:{"cols":{default: 3, 1279: 2, 800: 1},"gutter":30}},_vm._l((_vm.projects),function(project){return _c('PortfolioItem',{key:project.name,staticClass:"portfolio-item",attrs:{"project-object":project}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }